export enum IntellimixType {
	Basic = 'BASIC',
	Advanced = 'ADVANCED'
}
